const bundleController = Object.assign({}, {
    hm: null,
    mainProductAlias: false,
    currentProductAlias: false,

    init: function () {
        let navItems = document.querySelectorAll('[data-zit-product-alias]');

        navItems.forEach((navItem) => {
            let productAlias = navItem.dataset.zitProductAlias;
            let tabAlias = typeof navItem.dataset.zitDefaultTab !== typeof udnefined ? navItem.dataset.zitDefaultTab : false;
            navItem.addEventListener('click', (e) => {
                e.preventDefault();
                this.navTo(productAlias, tabAlias);
            });

            if (navItem.classList.contains('active')) {
                this.currentProductAlias = navItem.dataset.zitProductAlias;
            }
        });

        this.mainProductAlias = this.currentProductAlias;

        //show image
        //show title
        //show actions
        //close other open submenus
        //show only clicked tab
    },

    navTo: function (productAlias, tabAlias) {
        if (productAlias !== this.currentProductAlias) {
            //hide previous / show new 
            //display image
            let currentDisplayImageId = 'display_image_' + this.currentProductAlias;
            this.hm.helper.hideElement(currentDisplayImageId);
            let newDisplayImageId = 'display_image_' + productAlias;
            this.hm.helper.showElement(newDisplayImageId);

            //subtitle
            if (this.currentProductAlias !== this.mainProductAlias) {
                let currentTitleId = 'subtitle_' + this.currentProductAlias;
                this.hm.helper.hideElement(currentTitleId);
            }

            if (productAlias !== this.mainProductAlias) {
                let newTitleId = 'subtitle_' + productAlias;
                this.hm.helper.showElement(newTitleId);
            }

            //actions
            let currentActionsId = 'actions_' + this.currentProductAlias;
            this.hm.helper.hideElement(currentActionsId);
            let newActionsId = 'actions_' + productAlias;
            this.hm.helper.showElement(newActionsId);

            //close other product accordions
            document.querySelectorAll('.accordion-collapse').forEach((accordionEl) => {
                let accordionProductAlias = accordionEl.dataset.zitAccordionFor;
                if (accordionProductAlias != productAlias) {
                    //close this accordion
                    let collapsible = bootstrap.Collapse.getInstance(accordionEl);
                    
                    if (collapsible !== null) {
                        collapsible.hide();
                    }
                }
            });

            
            if (tabAlias !== false) {
                document.querySelectorAll('a.nav-link').forEach((navEl) => {
                    if (navEl.classList.contains('active')) {
                        navEl.classList.remove('active');
                    }
                });

                document.querySelectorAll('.tab-pane').forEach((tabContentEl) => {
                    if (tabContentEl.classList.contains('active')) {
                        tabContentEl.classList.remove('active', 'show');
                    }
                });

                let triggerElId = 'tab-' + tabAlias;
                let triggerEl = document.getElementById(triggerElId);
                let tab = bootstrap.Tab.getOrCreateInstance(triggerEl);
                tab.show();
            }
            
        }

        this.currentProductAlias = productAlias;
    }
});

module.exports = bundleController;